import type { CustomDataMap, DataPointEventType } from "owa-analytics-types";
import { getApp, 
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports -- (https://aka.ms/OWALintWiki)
 * Remove reference to getHostValue
 *	> 'getHostValue' import from 'owa-config' is restricted. Please use isFeatureEnabled/isBootFeatureEnabled instead. Host value is checked with ECS/CT as a filter. */
getHostValue, getLogicalRing, getSessionId, getClientId, getLayout, } from "owa-config";
import { getThreadName } from "owa-thread-config";
// eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki) Using the value for analytics
import { getPhysicalRing } from "owa-metatags";
import { getEnhancedHostDeviceId } from "owa-config/lib/enhancedHost";
import type { CustomDataWithoutUndefined, CustomEvent } from "./analyticsTypes";
import { getSessionElapseTime } from "owa-analytics-utils";

export function createEvent(table: DataPointEventType, eventName: string, data?: CustomDataMap, customColumns?: CustomDataWithoutUndefined, sampledRate?: number): CustomEvent {
    const event: CustomEvent = {
        name: table,
        data: {
            EventName: eventName,
            App: getApp(),
            Host: getHostValue() ?? "",
            Ring: getLogicalRing() ?? "",
            PhysicalRing: getPhysicalRing() ?? "",
            "Session.Id": getSessionId(),
            SessionElapseTime: getSessionElapseTime() ?? "",
            MiscData: data ? JSON.stringify(data) : "",
            Thread: getThreadName()?.toString() ?? "",
            ClientId: getClientId() ?? "",
            DeviceId: getEnhancedHostDeviceId() ?? "",
            Layout: getLayout(),
            Sampled: sampledRate ?? 100,
            ...customColumns,
        },
    };
    
    return event;
}
